// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__EqY15","content":"RecentSearches_content__2az3J"};